import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'formatSize',
})
export class FormatSizePipe implements PipeTransform {
  transform(bytes: number | null, decimals: number = 2): string {
    if (bytes === 0 || bytes === null) return '0 B';

    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    const formattedSize = parseFloat(
      (bytes / Math.pow(k, i)).toFixed(decimals)
    );
    return `${formattedSize} ${sizes[i]}`;
  }
}
